import React, { Component } from "react";
import Header from "./MaintenanceHeader/Header/Header";
import './Maintenance.scss';

class MaintenancePage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            supportInfo: false
        }
    }


    toggleSupportInfo = () => {
        let si = !this.state.supportInfo;
        this.setState({
            ...this.state,
            loginInfo: false,
            supportInfo: si
        });
    }

    closeInfoBox = () => {
        this.setState({
            ...this.state,
            loginInfo: false,
            supportInfo: false
        });

    }


    render() {
        return (
            <div className="maintenance">
                <Header />
                <div className="maint-main">
                    <div className="dx-col">
                        <header> Maintenance In Progress </header>
                        <div className="header-accent"></div>
                        <div className="text-block">
                            Thanks for visiting the Payment Portal. We are in the process of making some enhancements which will be available starting February 10. In the interim, if you have any questions or need to make a payment, we are available to assist you at <strong><a href="tel:+1-888-978-5371" tabindex="0">1-888-978-5371</a></strong> (Mon to Fri 8:00 am to 8:30 pm ET) or at <strong><a href="mailto:billing.pl@privateclientselect.com" tabindex="0">billing.pl@privateclientselect.com</a></strong>
                            <br></br> <br></br>

                            To make a payment via check, please send it at the following address: <br></br>
                            AIG<br></br>
                            PO Box 35423, Newark, NJ 07193-5423
                            <br></br>
                            <br></br>
                            <i>Thank you for your business!</i>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default MaintenancePage;


// WEBPACK FOOTER //
// ./src/components/atomic/pages/MaintenancePage/MaintenancePage.js